<template>
	<div class="splash-screen d-flex align-items-center justify-content-center" v-if="active">
		<div>
			<div class="lds-ellipsis">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
			<div v-if="data.showcancel">
				<u class="cur-point" @click="closeLoading">取消讀取畫面</u>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
	// <div class="splash-screen" v-if="active">
	// 		<div class="spinner-wrapper">
	// 			<div class="spinner"></div>
	// 		</div>
	// 	</div>
	import { timeout } from "tom-select/utils";
	import usePub from "~/store/Public";
	const props = defineProps({
		routerShow: Boolean,
		default: null,
	});
	const data = ref({
		showcancel: false,
	});
	// const props = defineProps([{
	// 	show:Boolean
	// }])
	onMounted(() => {});
	const active = computed({
		get() {
			// return true;
			// console.log( usePub().LoadingShow);
			return props.routerShow || usePub().loading || usePub().routeTran || usePub().LoadingShow;
		},
		set(data) {},
	});
	const closeLoading = () => {
		usePub().loading = false;
	};
	watch(
		() => {
			return active.value;
		},
		(nval) => {
			if (nval) {
				timeout(() => {
					data.value.showcancel = true;
				}, 3000);
			}else{
				data.value.showcancel = false
			}
		},
	);
	// export default defineComponent({
	//     props:{
	//         active:Boolean,
	//         isFullPage:Boolean
	//     },
	//     setup(props,{emit}){

	//     }
	// })
</script>

<style lang="scss">
	@import "@/style/color";
	.splash-screen {
		background: rgba(242, 240, 238, 0.4);
		width: 100vw;
		height: 100vh;
		position: fixed;
		z-index: 999999;
		top: 0;
		left: 0;
	}
	.lds-ellipsis {
		display: inline-block;
		position: relative;

		width: 80px;
		height: 80px;
	}

	.lds-ellipsis div {
		position: absolute;
		top: 33px;
		width: 13px;
		height: 13px;
		border-radius: 50%;
		background: $webMain;
		animation-timing-function: cubic-bezier(0, 1, 1, 0);
	}

	.lds-ellipsis div:nth-child(1) {
		left: 8px;
		animation: lds-ellipsis1 0.6s infinite;
	}

	.lds-ellipsis div:nth-child(2) {
		left: 8px;
		animation: lds-ellipsis2 0.6s infinite;
	}

	.lds-ellipsis div:nth-child(3) {
		left: 32px;
		animation: lds-ellipsis2 0.6s infinite;
	}

	.lds-ellipsis div:nth-child(4) {
		left: 56px;
		animation: lds-ellipsis3 0.6s infinite;
	}

	@keyframes lds-ellipsis1 {
		0% {
			transform: scale(0);
		}

		100% {
			transform: scale(1);
		}
	}

	@keyframes lds-ellipsis3 {
		0% {
			transform: scale(1);
		}

		100% {
			transform: scale(0);
		}
	}

	@keyframes lds-ellipsis2 {
		0% {
			transform: translate(0, 0);
		}

		100% {
			transform: translate(24px, 0);
		}
	}
</style>
<!-- <style lang="scss">
	@import "~/style/color";
	.splash-screen {
		background: rgba(242, 240, 238, 0.4);
		width: 100vw;
		height: 100vh;
		position: fixed;
		z-index: 9999;
		top: 0;
	}

	.spinner-wrapper {
		position: absolute;
		left: 50%;
		top: 50%;

		transform: translate(-50%, -50%);
	}
	.spinner {
		width: 80px;
		height: 80px;
		margin: 100px auto;
		background-color: $webMain;

		border-radius: 100%;
		-webkit-animation: sk-scaleout 1s infinite ease-in-out;
		animation: sk-scaleout 1s infinite ease-in-out;
	}

	@-webkit-keyframes sk-scaleout {
		0% {
			background-color: $webMain;
			-webkit-transform: scale(0);
		}
		100% {
			background-color: $webMain;
			-webkit-transform: scale(1);
			opacity: 0;
		}
	}

	@keyframes sk-scaleout {
		0% {
			background-color: $webMain;
			-webkit-transform: scale(0);
			transform: scale(0);
		}
		100% {
			background-color: $webMain;
			-webkit-transform: scale(1);
			transform: scale(1);
			opacity: 0;
		}
	}
</style> -->
